import classNames from 'classnames';
import isString from 'lodash/isString';
import {
  AlertTriangle,
  CheckCircle2,
  Info as InfoIcon,
  XCircle,
} from 'lucide-react';
import React from 'react';

type Props = {
  title?: string;
  content: string | JSX.Element;
  className?: string;
  type?: 'error' | 'warning' | 'info' | 'success' | 'green';
};

export const Info: React.FC<Props> = ({
  title,
  content,
  type = 'info',
  ...rest
}): JSX.Element => {
  return (
    <div
      className={classNames(
        'mb-4 flex gap-2 border-l-4 p-3 [text-wrap:pretty]',
        {
          'border border-l-error text-black-600': type === 'error',
          'border border-l-warning text-black-600': type === 'warning',
          'border border-l-blue text-black-600': type === 'info',
          'border border-l-success text-black-600': type === 'success',
          'border border-green-matte-100 border-l-green-gloss bg-green-matte-50 text-green-gloss/80':
            type === 'green',
        },
      )}
      {...rest}
    >
      {type === 'error' && (
        <XCircle size={20} className="h-5 w-5 shrink-0 text-error" />
      )}
      {type === 'warning' && (
        <AlertTriangle size={20} className="h-5 w-5 shrink-0 text-warning" />
      )}
      {type === 'info' && (
        <InfoIcon size={20} className="h-5 w-5 shrink-0 text-blue" />
      )}
      {type === 'success' && (
        <CheckCircle2 size={20} className="h-5 w-5 shrink-0 text-success" />
      )}
      <div>
        {title && (
          <p className="mb-1 text-base font-bold text-black">{title}</p>
        )}
        {isString(content) ? (
          <p
            className="text-base"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          content
        )}
      </div>
    </div>
  );
};
